import './drop.css';
import { renderGameMessage, startBlockedMessage } from '../shared/game-message';

const SCRIPT_URL = '/build/games/drop/drop.min.js';

import imgGameIcon from '../../images/game-icon.svg';
import imgNoMiss from './images/welcome-screen/no-miss.png';
import imgHeartsFull from './images/welcome-screen/hearts-full.svg';
import imgHeartsLost from './images/welcome-screen/hearts-lost.svg';
import imgHeartsEmpty from './images/welcome-screen/hearts-empty.svg';
import imgHeartsBonus from './images/welcome-screen/heart-bonus.svg';

export const WELCOME_CONFIG = {
    icon: imgGameIcon,
    title: 'Witaj w Catch It! 🎮✨',
    description: '<p><strong>Przygotuj się na szybką grę pełną refleksu i dobrej zabawy!</strong></p>' +
        '<p>Twoim zadaniem jest łapanie spadających przedmiotów i zdobycie jak największej liczby punktów.</p>',
    scoring: {
        heading: 'PUNKTACJA',
        body:
            '<ol>' +
            '<li>✅ Złapany HOT element +1pkt</li>' +
            '<li>❌ Brak złapanego HOT elementu – utrata życia</li>' +
            '<li>Specjalny element: dodatkowe życie</li>' +
            '</ol>' +
            '<p>🏆 Maksymalny wynik to 40 pkt</p>',
    },
};

import imgBackground from './images/background.webp';
import imgBucket from './images/bag.png';
import imgOof from './images/oof.webp';
import imgLevelUp from './images/lvl-up.webp';
import imgHeartFull from './images/heart-full.png';
import imgHeartEmpty from './images/heart-empty.png';
import imgDefaultSpecial from './images/sprites/special/oscar.png';
import imgDefaultGood1 from './images/sprites/good/good-1.png';
import imgDefaultGood2 from './images/sprites/good/good-2.png';
import imgDefaultGood3 from './images/sprites/good/good-3.png';
import imgDefaultGood4 from './images/sprites/good/good-4.png';
import imgDefaultGood5 from './images/sprites/good/good-5.png';
import imgDefaultBad1 from './images/sprites/bad/bad-1.png';
import imgDefaultBad2 from './images/sprites/bad/bad-2.png';
import imgDefaultBad3 from './images/sprites/bad/bad-3.png';
import imgDefaultBad4 from './images/sprites/bad/bad-4.png';
import imgDefaultBad5 from './images/sprites/bad/bad-5.png';

const DEFAULT_GOOD_SPRITES = [imgDefaultGood1, imgDefaultGood2, imgDefaultGood3, imgDefaultGood4, imgDefaultGood5];
const DEFAULT_BAD_SPRITES = [imgDefaultBad1, imgDefaultBad2, imgDefaultBad3, imgDefaultBad4, imgDefaultBad5];

export function buildDropWelcome(data) {
    const goodSprites   = data?.dropGame?.sprites?.good    ?? DEFAULT_GOOD_SPRITES;
    const badSprites    = data?.dropGame?.sprites?.bad     ?? DEFAULT_BAD_SPRITES;
    const specialSprite = data?.dropGame?.sprites?.special ?? imgDefaultSpecial;
    const specialEffect = data?.dropGame?.config?.specialEffect ?? 'life';

    return {
        ...WELCOME_CONFIG,
        howToPlay: {
            heading: 'JAK GRAĆ?',
            slides: [
                {
                    heading: '',
                    body: '<ol>' +
                        '<li>Przesuwaj torebką po ekranie, aby łapać spadające HOT przedmioty.</li>' +
                        '<li>Omijaj pozostałe i pilnuj wyniku.</li>' +
                        '<li>Reaguj szybko – im lepszy refleks, tym większa szansa na rekord!</li>' +
                        '</ol>' +
                        '<p>Gotowy? Sprawdź, ile punktów uda Ci się zdobyć! 👑✨</p>',
                },
                {
                    heading: 'ŁAP',
                    image: imgHeartsFull,
                    images: goodSprites,
                    body: '<p>Aby zachować komplet serduszek, łap do torby wyłącznie to co HOT!</p>',
                },
                {
                    heading: 'UWAŻAJ',
                    image: imgHeartsLost,
                    images: [imgNoMiss],
                    body: '<p>Nie przegap niczego, co HOT, bo stracisz serduszko!',
                },
                {
                    heading: 'OMIJAJ',
                    image: imgHeartsEmpty,
                    images: badSprites,
                    body: '<p>Unikaj pułapek! Utrata trzech serduszek to koniec gry :(</p>',
                },
                {
                    heading: 'SPECJALNY',
                    image: imgHeartsBonus,
                    images: [specialSprite],
                    body: specialEffect === 'life'
                        ? '<p>Nie przegap elementów specjalnych, łap je żeby zebrać dodatkowe życia.</p>'
                        : '<p>Nie przegap elementów specjalnych, łap je dla specjalnego bonusu punktowego.</p>',
                },
            ],
        },
    };
}

// Full default levels from config.game.js — hFn/pos must stay as functions here.
// Level image asset keys map to assetsConfig.images entries below.
const DEFAULT_LEVELS = [
    {threshold: 100, spawnInterval: 1600, speedMultiplier: 1.0, specialLimit: 2},
    {
        threshold: 220,
        spawnInterval: 1450,
        speedMultiplier: 1.12,
        specialLimit: 1,
        label: 'IDZIE CI ŚWIETNIE!', sub: 'Graj dalej, aby odblokować kolejny poziom',
    },
    {
        threshold: 350,
        spawnInterval: 1300,
        speedMultiplier: 1.25,
        specialLimit: 1,
        label: 'IDZIE CI ŚWIETNIE!', sub: 'Graj dalej, aby odblokować kolejny poziom',
    },
    {
        threshold: 490,
        spawnInterval: 1160,
        speedMultiplier: 1.40,
        specialLimit: 1,
        label: 'IDZIE CI ŚWIETNIE!', sub: 'Graj dalej, aby odblokować kolejny poziom',
    },
    {
        threshold: 640,
        spawnInterval: 1030,
        speedMultiplier: 1.55,
        specialLimit: 1,
        label: 'IDZIE CI ŚWIETNIE!', sub: 'Graj dalej, aby odblokować kolejny poziom',
    },
    {
        threshold: 810,
        spawnInterval: 910,
        speedMultiplier: 1.72,
        specialLimit: 1,
        label: 'IDZIE CI ŚWIETNIE!', sub: 'Graj dalej, aby odblokować kolejny poziom',
    },
    {
        threshold: 990,
        spawnInterval: 800,
        speedMultiplier: 1.90,
        specialLimit: 1,
        label: 'IDZIE CI ŚWIETNIE!', sub: 'Graj dalej, aby odblokować kolejny poziom',
    },
    {
        threshold: 1180,
        spawnInterval: 700,
        speedMultiplier: 2.10,
        specialLimit: 1,
        label: 'IDZIE CI ŚWIETNIE!', sub: 'Graj dalej, aby odblokować kolejny poziom',
    },
    {
        threshold: 1380,
        spawnInterval: 610,
        speedMultiplier: 2.32,
        specialLimit: 1,
        label: 'IDZIE CI ŚWIETNIE!', sub: 'Graj dalej, aby odblokować kolejny poziom',
    },
    {
        threshold: 1590,
        spawnInterval: 530,
        speedMultiplier: 2.56,
        specialLimit: 1,
        label: 'IDZIE CI ŚWIETNIE!', sub: 'Graj dalej, aby odblokować kolejny poziom',
    },
    {
        threshold: Infinity,
        spawnInterval: 460,
        speedMultiplier: 2.80,
        specialLimit: Infinity,
        label: 'IDZIE CI ŚWIETNIE!', sub: 'Graj dalej, aby odblokować kolejny poziom',
    },
];

let gameInstance  = null;
let currentTaskId = null;
let lastResult    = null;

function loadScript(src) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
        }
        const s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
    });
}

function contentEl(modal) {
    return modal.querySelector('.game-modal__content');
}

function warmCache(urls) {
    return Promise.all(urls.map(url => new Promise(resolve => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = resolve;
        img.src = url;
    })));
}

export function renderDrop(modal, data, markCardDone) {
    const taskId = data.task.id;
    currentTaskId = taskId;

    const el = contentEl(modal);
    el.innerHTML = '';

    const containerId = 'drop-game-container';
    const container = document.createElement('div');
    container.id = containerId;
    container.className = 'drop-game';
    el.appendChild(container);

    loadScript(SCRIPT_URL)
        .then(() => warmCache([
            imgHeartFull, imgHeartEmpty,
            imgBackground, imgBucket, imgOof, imgLevelUp, imgDefaultSpecial,
            ...DEFAULT_GOOD_SPRITES, ...DEFAULT_BAD_SPRITES,
        ]))
        .then(() => {
            if (typeof DropGame === 'undefined') {
                console.error('DropGame: script loaded but DropGame is not defined');
                return;
            }

            gameInstance = DropGame.init(containerId, {
                assetsConfig: {
                    texts: {
                        tapToContinue: 'Dotknij aby kontynuować',
                        continueButton: 'Kontynuuj',
                        levelUpButton: 'NASTĘPNY POZIOM',
                        startPages: [],
                        scoreLabel: 'PUNKTY:',
                        endPositiveTitle: 'HAPPY END!',
                        endPositiveScore: 'Straciłaś wszystkie życia, następnym razem pójdzie Ci lepiej ;)',
                        endNegativeBody: 'UPS!',
                        endLoadingText: 'Ładowanie',
                        rankingTitle: '',
                        rankingColCast: '',
                        rankingColScore: '',
                        rankingButtonAdd: '',
                        rankingButtonSave: '',
                        rankingButtonNext: '',
                    },
                    images: {
                        background: imgBackground,
                        bucket: imgBucket,
                        specialSprite: imgDefaultSpecial,
                        oof: imgOof,
                        levelUp: imgLevelUp,
                        lifeIndicator: imgHeartFull,
                        lostLifeIndicator: imgHeartEmpty,
                        goodSprites: DEFAULT_GOOD_SPRITES,
                        badSprites: DEFAULT_BAD_SPRITES,
                    },
                    sounds: {},
                    colors: {
                        primary: [15, 130, 30],
                        secondary: [212, 24, 28],
                        brandRed: '#d41824',
                        surface: 'rgba(255, 255, 240, 1)',
                        dark: '#111111',
                        btnGradient: 'linear-gradient(160deg, #FFAF45 9.47%, #FF4E31 49.5%, #FF66CC 89.54%)',
                    },
                },
                gameConfig: {
                    maxLives: data.dropGame?.config?.maxLives ?? 3,
                    specialEffect: data.dropGame?.config?.specialEffect ?? 'life',
                    specialPoints: data.dropGame?.config?.specialPoints ?? 50,
                    itemPoints: data.dropGame?.config?.itemPoints ?? 10,
                    baseItemSpeed: 3,
                    loadingDuration: 2500,
                    catcherWidthRatio: 0.28,
                    referenceWidth: 550,
                    referenceHeight: 700,
                    specialSpawnChance: 0.12,
                    levels: (data.dropGame?.levels ?? DEFAULT_LEVELS).map((l, i) => ({
                        ...l,
                        threshold: l.threshold ?? Infinity,
                        specialLimit: l.specialLimit ?? Infinity,
                        ...(i > 0 ? {label: 'IDZIE CI ŚWIETNIE!', sub: 'Graj dalej, aby odblokować kolejny poziom'} : {}),
                    })),
                },
                apiConfig: {
                    useMock: false,
                    endpoints: {
                        startGame: `/api/task/${taskId}/drop/start`,
                        heartbeat: `/api/task/${taskId}/drop/heartbeat`,
                        submitResult: `/api/task/${taskId}/drop/submit`,
                    },
                },
                callbacks: {
                    onError: (error) => {
                        if (error?.status === 409 && (error.data?.error === 'already_completed' || error.data?.error === 'game_in_progress')) {
                            renderGameMessage(modal, startBlockedMessage(error.data?.error));
                            return;
                        }
                        document.dispatchEvent(new CustomEvent('game-modal:request-close'));
                        console.error('DropGame error:', error);
                    },
                    onComplete: (result) => {
                        markCardDone({rankingPointsEarned: result.rankingPointsEarned ?? 0, redeemablePointsEarned: result.redeemablePointsEarned ?? 0, checkIn: result.checkIn});
                        lastResult = result;
                    },
                    onGameEnd: () => {
                        if (lastResult) {
                            document.dispatchEvent(new CustomEvent('game-modal:result-show', {
                                detail: {
                                    rankingPoints: lastResult.rankingPointsEarned ?? 0,
                                    redeemablePoints: lastResult.redeemablePointsEarned ?? 0,
                                },
                            }));
                        }
                    },
                },
            });
        })
        .catch(() => {
            document.dispatchEvent(new CustomEvent('game-modal:request-close'));
            console.error('DropGame: failed to load game script');
        });
}

export function pauseDrop() {
    if (gameInstance) {
        try {
            gameInstance.pause();
        } catch { /* ignore */ }
    }
}

export function resumeDrop() {
    if (gameInstance) {
        try {
            gameInstance.resume();
        } catch { /* ignore */ }
    }
}

export async function forceEndDrop() {
    if (gameInstance) {
        try {
            if (currentTaskId !== null) {
                await fetch(`/api/task/${currentTaskId}/drop/flag-force-end`, { method: 'POST' });
            }
            gameInstance.forceEnd();
        } catch { /* ignore */ }
    }
}

export function teardownDrop(modal) {
    if (gameInstance) {
        try {
            gameInstance.destroy();
        } catch { /* ignore */
        }
        gameInstance = null;
    }
    currentTaskId = null;
    lastResult = null;
    const el = contentEl(modal);
    if (el) el.innerHTML = '';
}
